<template>
  <div class="my-10">
    <LikedNav />

    <h1 class="font-bold text-xl mb-4 hidden max-md:flex">
      {{ $t('nav.publicationLiked') }}
    </h1>

    <!-- СПИСОК -->
    <div
      v-if="Array.isArray($store.publicationLiked)"
      class="grid grid-cols-4 gap-4 max-lg:grid-cols-3 max-md:grid-cols-2"
    >
      <template v-for="item in $store.publicationLiked" :key="item.id">
        <router-link :to="{ name: 'publicationDetail', params: { id: item.id } }">
          <PublicationCard :detail="item" />
        </router-link>
      </template>
    </div>

    <!-- LOADING -->
    <div v-if="loading" class="flex justify-center mx-auto w-full" role="status">
      <IconSpinner class="w-12 h-12 mr-2 text-gray-200 animate-spin fill-main-color" />
      <span class="sr-only">Loading...</span>
    </div>

    <!-- ПУСТО -->
    <div
      v-if="!loading && Array.isArray($store.publicationLiked) && !$store.publicationLiked.length"
    >
      <p class="text-xl font-medium whitespace-nowrap">
        {{ $t('page.no_liked') }}
      </p>
    </div>
  </div>
</template>

<script>
import api from '@/api';
import PublicationCard from '@cmp/publication/PublicationCard.vue'
import LikedNav from '@cmp/profile/LikedNav.vue'
export default {
    name: 'publicationLiked',
    components: {
        LikedNav,
        PublicationCard,
    },
    data() {
        return {
            loading: false,
            publications: []
        }
    },
    methods: {
      
    },
    computed: {

    },
    created() {
    }
}

</script>
<style scoped>
.router-link-exact-active{
    border-bottom: 1px solid #409DBA;
    color: #000000;
}
</style>